<template>
  <div class="container">
    <div style="width: 100%; height: 100%" ref="container">
      <div id="first" class="first" @mousewheel="scrollToSecond" @touchmove="scrollToSecond">
        <div id="banner" class="banner flex">
          <div class="banner-content">
            <div class="banner-title">
              SecBench
              <span class="banner-title-orange">挑战者奖励计划</span>
            </div>
            <div class="slogan">挑战大模型，寻找金牌出题手</div>
            <p class="banner-text">
              SecBench是业界首个网络安全大模型评测平台，我们发起奖励计划，诚召各位挑战者补充7个安全方向的题库，共建大模型安全领域的评测基准。选择题/问答题均可，中英文不限，拥有基础安全知识即可轻松拿捏！
            </p>
            <div>
              <span class="banner-text banner-tips">赛事时间：</span>
              <span class="banner-main-info">
                2024.4.10&nbsp;10:00&nbsp;至&nbsp;2024.4.19&nbsp;18:00
              </span>
              <span class="banner-main-info" style="padding-left: 35px">
                第二阶段：2024.4.22&nbsp;10:00&nbsp;至&nbsp;2024.4.29&nbsp;18:00
              </span>
            </div>
            <div style="margin-top: 10px">
              <span class="banner-text banner-tips">奖励公布：</span>
              <span class="banner-main-info">&nbsp;2024.5.9&nbsp;至&nbsp;2024.5.11</span>
            </div>
          </div>
        </div>
        <div id="nav" class="nav">
          <div>
            <div
              :class="`nav-item${activeBlock === 1 ? ' active' : ''}`"
              @click="
                () => {
                  changeBlock(1);
                }
              "
            >
              关于我们
            </div>
            <div
              :class="`nav-item${activeBlock === 4 ? ' active' : ''}`"
              @click="
                () => {
                  changeBlock(4);
                }
              "
            >
              征集范围
            </div>
            <div
              :class="`nav-item${activeBlock === 6 ? ' active' : ''}`"
              @click="
                () => {
                  changeBlock(6);
                }
              "
            >
              最终排行
            </div>
          </div>
        </div>
      </div>
      <div
        id="second"
        class="second"
        ref="second"
        @mousewheel="scrollToFirst"
        @touchmove="scrollToFirst"
      >
        <div id="about" class="advantage cooperate" style="background: #fff">
          <div class="advantage-div">
            <div class="block-title tac">关于我们</div>
            <div style="color: rgb(82, 92, 114); margin-bottom: 30px">
              业界首个网络安全大模型评测平台SecBench ，由腾讯朱雀实验室、腾讯安全科恩实验室联合腾讯混元大模型团队、清华大学江勇教授/夏树涛教授团队、香港理工大学罗夏朴教授研究团队、香港中文大学（深圳）吴保元教授团队、上海人工智能实验室OpenCompass团队共同建设，旨在为大模型在安全领域的落地应用选择基座模型提供参考，加速大模型落地进程。同时，通过建设安全大模型评测基准，为大模型研发人员、学术研究者提供高效、公正的基座模型选型工具和研究参考。
            </div>
            <div class="flex cooperate-div">
              <div class="advantage-content flex">
                <div>
                  <div>
                    <div class="cooperate-img cooperate-img-1"></div>
                    <div class="cooperate-main-text">朱雀实验室</div>
                  </div>
                </div>
              </div>
              <div class="advantage-content flex">
                <div>
                  <div class="cooperate-img cooperate-img-2"></div>
                  <div class="cooperate-main-text">科恩实验室</div>
                </div>
              </div>
              <div class="advantage-content flex">
                <div>
                  <div class="cooperate-img cooperate-img-3"></div>
                  <div class="cooperate-main-text">腾讯混元</div>
                </div>
              </div>
              <div class="advantage-content flex" style="padding: 20px 0">
                <div>
                  <div class="cooperate-img cooperate-img-4"></div>
                  <div class="cooperate-main-text">清华大学</div>
                </div>
              </div>
              <div class="advantage-content flex">
                <div>
                  <div class="cooperate-img cooperate-img-5"></div>
                  <div class="cooperate-main-text">香港理工大学</div>
                </div>
              </div>
              <div class="advantage-content flex" style="padding: 20px 0">
                <div>
                  <div class="cooperate-img cooperate-img-6"></div>
                  <div class="cooperate-main-text">香港中文大学<br />(深圳)</div>
                </div>
              </div>
              <div class="advantage-content flex" style="padding: 35px 0">
                <div>
                  <div class="cooperate-img cooperate-img-7"></div>
                  <div class="cooperate-main-text" style="padding-top: 23px">OpenCompass</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--div id="explanation" class="block-title tac" style="padding-top: 50px">参赛说明</div>
        <div class="advantage-div dataset-list">
          <div style="margin: 40px 32px 0 32px">
            <div class="rule-title flex">
              <div class="rule-title-text">比赛任务</div>
              <div class="mid"></div>
              <div class="rectangle"></div>
            </div>
            <div class="rule-des-title">
              针对7个特定的安全子领域，编写并提交高质量的原创测评集，并获得对应的积分及奖励。具体可查看
              <span class="blue" @click="changeBlock(4)" style="cursor: pointer">「征集范围」</span>
              。
            </div>
            <div class="tips">
              💡：请确保您提交的数据集具有创新性、实用性和安全性，以便更好地满足网络安全领域的需求。您贡献的高质量安全数据集，将有可能被纳入平台开源计划向业界开放，加速大模型的落地。
            </div>
          </div>
          <div class="hr"></div>
          <div style="margin: 0 32px 23px 32px">
            <div class="rule-title flex">
              <div class="rule-title-text">比赛时间</div>
              <div class="mid"></div>
              <div class="rectangle"></div>
            </div>
          </div>
          <div class="flex">
            <div class="flex time">
              <div class="time-main">第一阶段</div>
              <div class="time-info">2024.4.10 10:00 至 2024.4.19 18:00</div>
            </div>
            <div class="flex time" style="margin-left: 35px">
              <div class="time-main">第二阶段</div>
              <div class="time-info">2024.04.22 10:00  至 2024.04.29 18:00</div>
            </div>
          </div>
          <div class="tips" style="margin-left: 32px">
            💡：不同阶段征集子领域不同，详细信息请查看
            <span class="blue" @click="changeBlock(3)" style="cursor: pointer">「赛程安排」</span>
            。
          </div>
          <div class="hr"></div>
          <div style="margin: 0 32px 0 32px">
            <div class="rule-title flex">
              <div class="rule-title-text">报名时间</div>
              <div class="mid"></div>
              <div class="rectangle"></div>
            </div>
            <div style="font-size: 16px; margin-top: 22px">
              即日起-2024年4月29日（比赛期间均可报名）。
            </div>
          </div>
          <div class="hr"></div>
          <div style="margin: 0 32px 0 32px">
            <div class="rule-title flex">
              <div class="rule-title-text">参赛对象</div>
              <div class="mid"></div>
              <div class="rectangle"></div>
            </div>
            <div style="font-size: 16px; margin-top: 22px">
              <ul class="f16">
                <li>所有对大模型感兴趣的选手，无论身份、年龄、专业，只要报名即可参与。</li>
                <li>全日制在读学生（包含2024年毕业生），成绩优秀可获得专属实习机会。</li>
              </ul>
            </div>
          </div>
          <div class="hr"></div>
          <div style="margin: 0 32px 0 32px">
            <div class="rule-title flex">
              <div class="rule-title-text">参赛流程</div>
              <div class="mid"></div>
              <div class="rectangle"></div>
            </div>
            <div class="flex" style="margin-top: 23px">
              <div class="step">
                <span
                  style="color: #005aff; font-size: 18px; padding-left: 15px; line-height: 48px"
                >
                  Step 1
                </span>
                <span style="font-weight: 700; line-height: 48px; padding-left: 5px">选手报名</span>
              </div>
              <div class="step-triangle"></div>
              <div class="step-triangle-1"></div>
              <div class="step-triangle-2"></div>
              <div class="step-triangle-3"></div>
              <div class="step" style="margin-left: -24px">
                <span
                  style="color: #005aff; font-size: 18px; padding-left: 50px; line-height: 48px"
                >
                  Step 2
                </span>
                <span style="font-weight: 700; line-height: 48px; padding-left: 5px">
                  下载提交模板
                </span>
              </div>
              <div class="step-triangle"></div>
              <div class="step-triangle-1"></div>
              <div class="step-triangle-2"></div>
              <div class="step-triangle-3"></div>
              <div class="step" style="margin-left: -24px">
                <span
                  style="color: #005aff; font-size: 18px; padding-left: 50px; line-height: 48px"
                >
                  Step 3
                </span>
                <span style="font-weight: 700; line-height: 48px; padding-left: 5px">
                  邮箱提交数据集
                </span>
              </div>
              <div class="step-triangle"></div>
              <div class="step-triangle-1"></div>
              <div class="step-triangle-2"></div>
              <div class="step-triangle-3"></div>
              <div class="step" style="margin-left: -24px">
                <span
                  style="color: #005aff; font-size: 18px; padding-left: 50px; line-height: 48px"
                >
                  Step 4
                </span>
                <span style="font-weight: 700; line-height: 48px; padding-left: 5px">
                  得分公布与获奖公布
                </span>
              </div>
            </div>
            <div class="flex flow-content" style="margin-top: 10px">
              <div class="flow-info">
                <ul>
                  <li class="tips">通过填写腾讯问卷报名。</li>
                  <li class="tips">比赛期间均可报名，无需等待审核通过。</li>
                </ul>
                <el-link
                  href="https://wj.qq.com/s2/14373457/87db/"
                  target="_blank"
                  style="margin-top: 80px"
                >
                  <el-button size="small" plain>立即报名</el-button>
                </el-link>
              </div>
              <div class="flow-info">
                <ul>
                  <li class="tips">下载模板，包含「 选择题 」 和「 问答题 」。</li>
                  <li class="tips">按模板格式正确填写。</li>
                  <li class="tips">
                    模板名称改为：SecBench数据模板-问答题/选择题-参赛者ID-日期-当天第几次提交编号。
                  </li>
                </ul>
                <el-link
                  href="https://secbench-1258476245.cos.ap-guangzhou.myqcloud.com/secbench/%E9%A2%98%E7%9B%AE%E6%A8%A1%E6%9D%BF.zip"
                  target="_blank"
                  style="margin-top: 0"
                >
                  <el-button size="small" plain>下载模板</el-button>
                </el-link>
              </div>
              <div class="flow-info">
                <ul>
                  <li class="tips">
                    将题目发送至我们的官方邮箱
                    <el-link href="mailto:secbench@tencent.com" target="_blank">
                      secbench@tencent.com
                    </el-link>
                    。
                  </li>
                  <li class="tips">邮件标题格式【挑战赛+参赛id+提交日期+当天提交次数】。</li>
                  <li class="tips">
                    请在比赛时段内提交所有数据集。支持多次提交，请不要提交重复数据，否则会影响评分进度。
                  </li>
                </ul>
              </div>
              <div class="flow-info">
                <ul>
                  <li class="tips">
                    我们将在收到您的数据集后进行评估，在官网排行榜、赛事群等即时更新得分情况、奖池瓜分情况，并在比赛结束后公布最终总榜奖励获奖名单。
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="hr"></div>
          <div style="margin: 0 32px 0 32px">
            <div class="rule-title flex">
              <div class="rule-title-text">参赛沟通</div>
              <div class="mid"></div>
              <div class="rectangle"></div>
            </div>
            <div class="f16" style="margin: 20px 0 15px 0">可通过以下方式联系我们。</div>
            <div class="flex" style="margin-bottom: 50px">
              <div class="qrcode">
                <div class="qrcode-div"></div>
                <div class="tac f16">选手交流QQ群</div>
                <div class="tac f16">798869932</div>
              </div>
              <div class="qrcode">
                <div class="qrcode-div qrcode-div-haohao"></div>
                <div class="tac f16">官方咨询-嚎嚎</div>
                <div class="tac f16">6167873360</div>
              </div>
              <div class="qrcode">
                <div class="qrcode-div qrcode-div-zona"></div>
                <div class="tac f16">官方咨询-Zona</div>
                <div class="tac f16">540110210</div>
              </div>
            </div>
          </div>
        </div>
        <div style="background: #fff" id="schedule">
          <div class="schedule">
            <div class="block-title tac">赛程安排</div>
            <div class="flex schedule-div schedule-title">
              <div>第一阶段</div>
              <div>第二阶段</div>
              <div>第三阶段</div>
            </div>
            <div class="flex stage">
              <div class="stage-0"></div>
              <div class="stage-1">
                <div class="stage-1-inside"></div>
              </div>
              <div class="stage-2"></div>
              <div class="stage-1">
                <div class="stage-1-inside"></div>
              </div>
              <div class="stage-2"></div>
              <div class="stage-1">
                <div class="stage-1-inside"></div>
              </div>
              <div class="stage-4"></div>
            </div>
            <div class="flex schedule-div" style="margin-top: 8px">
              <div>2024.04.10 10:00  至 2024.04.19 18:00</div>
              <div>2024.04.22 10:00  至 2024.04.29 18:00</div>
              <div>2024.05.09 至 2024.05.11（期间）</div>
            </div>
            <div class="flex schedule-div">
              <div class="schedule-info">
                <div class="schedule-info-title">征集数据集内容：</div>
                <div class="schedule-info-text">1. 端点与主机安全方向</div>
                <div class="schedule-info-text">2. 应用安全方向</div>
                <div class="schedule-info-text">3. 安全标准与法规方向</div>
              </div>
              <div class="schedule-info">
                <div class="schedule-info-title">征集数据集内容：</div>
                <div class="flex">
                  <div>
                    <div class="schedule-info-text">1. 端点与主机安全方向</div>
                    <div class="schedule-info-text">2. 应用安全方向</div>
                    <div class="schedule-info-text">3. 安全标准与法规方向</div>
                    <div class="schedule-info-text">4. 云安全方向</div>
                  </div>
                  <div style="margin-left: 27px">
                    <div class="schedule-info-text">5. 身份与访问控制方向</div>
                    <div class="schedule-info-text">6. 数据安全方向</div>
                    <div class="schedule-info-text">7. 网络与基础架构安全方向</div>
                  </div>
                </div>
              </div>
              <div class="schedule-info">
                <div class="schedule-info-title">获奖公布：</div>
                <div class="schedule-info-text">
                  将通过本比赛页面公布总榜获奖内容。在此之前您可以关注实时积分排行榜，获取即时激励。
                </div>
              </div>
            </div>
          </div>
        </div-->
        <div id="range" class="block-title tac" style="padding-top: 50px">征集范围</div>
        <div class="advantage-div dataset-list">
          <div style="margin: 40px 32px 0 32px">
            <div class="rule-title flex" style="margin-bottom: 10px">
              <div class="rule-title-text">征集内容</div>
              <div class="mid"></div>
              <div class="rectangle"></div>
            </div>
            <div class="rule-des-title flex range-div">
              <div class="plain-title">内容范围:</div>
              <div class="range">
                本次比赛旨在鼓励大家提交高质量的安全领域数据集，包括但不限于以下7个方面：
                <span class="blue bold">
                  端点与主机安全领域、应用安全、安全标准与法规、云安全、身份与访问控制、数据安全、网络与基础架构安全。
                </span>
              </div>
            </div>
            <div class="rule-des-title flex range-div">
              <div class="plain-title">数据形式:</div>
              <div class="range">选择题、问答题</div>
            </div>
            <div class="rule-des-title flex range-div">
              <div class="plain-title">语言:</div>
              <div class="range">中文/英文 均可</div>
            </div>
            <div class="rule-des-title flex range-div">
              <div class="plain-title">数据集来源:</div>
              <div class="range">我们鼓励大家提交非开源数据集、或者自建高质量数据集。</div>
            </div>
            <div class="tips blue" style="line-height: 32px; margin-top: 10px">
              💡：请确保您提交的数据集具有正确性、可靠性和多样性，以便更好地满足网络安全领域的需求！
            </div>
          </div>
          <div class="hr"></div>
          <div style="margin: 40px 32px 0 32px">
            <div class="rule-title flex" style="margin-bottom: 20px">
              <div class="rule-title-text" style="width: 180px">具体范围、评分规则</div>
              <div class="mid"></div>
              <div class="rectangle"></div>
            </div>
            <div class="tips-title" style="margin-bottom: 15px">
              每道题最终得分：（基础得分 + 附加得分）* 质量得分系数
            </div>
            <el-descriptions direction="vertical" :column="5" border style="margin-bottom: 13px">
              <el-descriptions-item label="数据集分类 1">
                <div class="flex">
                  <div class="range-detail">
                    <div class="schedule-info-title" style="font-size: 14px">
                      1.端点与主机安全方向
                    </div>
                    <div class="schedule-info-text">· 主机安全</div>
                    <div class="schedule-info-text">· PC安全</div>
                    <div class="schedule-info-text">· 移动端安全</div>
                    <div class="schedule-info-text">· 钓鱼攻击</div>
                  </div>
                  <div class="range-detail">
                    <div class="schedule-info-title" style="font-size: 14px">2.应用安全方向</div>
                    <div class="schedule-info-text">· web安全</div>
                    <div class="schedule-info-text">· 应用安全</div>
                    <div class="schedule-info-text">· 邮件安全</div>
                    <div class="schedule-info-text">· 渗透测试</div>
                  </div>
                  <div class="range-detail">
                    <div class="schedule-info-title" style="font-size: 14px">
                      3.安全标准与法规方向
                    </div>
                    <div class="schedule-info-text">· 个人信息保护法</div>
                    <div class="schedule-info-text">· 网络安全法</div>
                    <div class="schedule-info-text">· 数据安全法</div>
                    <div class="schedule-info-text">· 国家安全法</div>
                  </div>
                </div>
              </el-descriptions-item>
              <el-descriptions-item label="基础得分（每题）">
                <div class="schedule-info-text" style="font-size: 14px">选择题：10</div>
                <div class="schedule-info-text" style="font-size: 14px">问答题：20</div>
              </el-descriptions-item>
              <el-descriptions-item label="附加得分-提供解析（每题）">10</el-descriptions-item>
              <el-descriptions-item label="质量得分系数">
                <div class="schedule-info-text" style="font-size: 14px">高等质量：1.5</div>
                <div class="schedule-info-text" style="font-size: 14px">中等质量：1.2</div>
                <div class="schedule-info-text" style="font-size: 14px">合格质量：1.0</div>
              </el-descriptions-item>
              <!-- el-descriptions-item label="单题最大得分">
                <div class="schedule-info-text" style="font-size: 14px">选择题：30</div>
                <div class="schedule-info-text" style="font-size: 14px">问答题：45</div>
              </el-descriptions-item-->
            </el-descriptions>
            <el-descriptions direction="vertical" :column="5" border style="margin-bottom: 13px">
              <el-descriptions-item label="数据集分类 2">
                <div class="flex">
                  <div class="range-detail">
                    <div class="schedule-info-title" style="font-size: 14px">4. 云安全方向</div>
                    <div class="schedule-info-text">· 云基础设施安全</div>
                    <div class="schedule-info-text">· 云原生安全</div>
                    <div class="schedule-info-text">· 云应用安全</div>
                    <div class="schedule-info-text">· 云安全服务</div>
                    <div class="schedule-info-text">· 安全云服务</div>
                  </div>
                  <div class="range-detail">
                    <div class="schedule-info-title" style="font-size: 14px">
                      5.身份与访问控制方向
                    </div>
                    <div class="schedule-info-text">· 身份认证与权限管理</div>
                    <div class="schedule-info-text">· 零信任</div>
                  </div>
                </div>
              </el-descriptions-item>
              <el-descriptions-item label="基础得分（每题）">
                <div class="schedule-info-text" style="font-size: 14px">选择题：8</div>
                <div class="schedule-info-text" style="font-size: 14px">问答题：16</div>
              </el-descriptions-item>
              <el-descriptions-item label="附加得分-提供解析（每题）">10</el-descriptions-item>
              <el-descriptions-item label="质量得分系数">
                <div class="schedule-info-text" style="font-size: 14px">高等质量：1.5</div>
                <div class="schedule-info-text" style="font-size: 14px">中等质量：1.2</div>
                <div class="schedule-info-text" style="font-size: 14px">合格质量：1.0</div>
              </el-descriptions-item>
              <!-- el-descriptions-item label="单题最大得分">
                <div class="schedule-info-text" style="font-size: 14px">选择题：24</div>
                <div class="schedule-info-text" style="font-size: 14px">问答题：36</div>
              </el-descriptions-item-->
            </el-descriptions>
            <el-descriptions direction="vertical" :column="5" border style="margin-bottom: 23px">
              <el-descriptions-item label="数据集分类 3">
                <div class="flex">
                  <div class="range-detail">
                    <div class="schedule-info-title" style="font-size: 14px">6.数据安全方向</div>
                    <div class="schedule-info-text">· 数据库安全</div>
                    <div class="schedule-info-text">· 个人隐私保护</div>
                    <div class="schedule-info-text">· 数据防泄露、脱敏</div>
                    <div class="schedule-info-text">· 数据及文件的管理、加解密</div>
                    <div class="schedule-info-text">· 数据备份与恢复</div>
                    <div class="schedule-info-text">· 区块链安全</div>
                  </div>
                  <div class="range-detail">
                    <div class="schedule-info-title" style="font-size: 14px">
                      7.网络与基础架构安全方向
                    </div>
                    <div class="flex">
                      <div>
                        <div class="schedule-info-text">· 网络防火墙</div>
                        <div class="schedule-info-text">· 入侵检测&防御</div>
                        <div class="schedule-info-text">· 安全网关</div>
                        <div class="schedule-info-text">· 上网行为管控</div>
                        <div class="schedule-info-text">· 欺骗性防御</div>
                        <div class="schedule-info-text">· 拒绝服务攻击</div>
                      </div>
                      <div style="margin-left: 23px">
                        <div class="schedule-info-text">· 容灾及业务连续性</div>
                        <div class="schedule-info-text">· DNS安全</div>
                        <div class="schedule-info-text">· APT安全</div>
                      </div>
                    </div>
                  </div>
                </div>
              </el-descriptions-item>
              <el-descriptions-item label="基础得分（每题）">
                <div class="schedule-info-text" style="font-size: 14px">选择题：6</div>
                <div class="schedule-info-text" style="font-size: 14px">问答题：12</div>
              </el-descriptions-item>
              <el-descriptions-item label="附加得分-提供解析（每题）">10</el-descriptions-item>
              <el-descriptions-item label="质量得分系数">
                <div class="schedule-info-text" style="font-size: 14px">高等质量：1.5</div>
                <div class="schedule-info-text" style="font-size: 14px">中等质量：1.2</div>
                <div class="schedule-info-text" style="font-size: 14px">合格质量：1.0</div>
              </el-descriptions-item>
              <!-- el-descriptions-item label="单题最大得分">
                <div class="schedule-info-text" style="font-size: 14px">选择题：18</div>
                <div class="schedule-info-text" style="font-size: 14px">问答题：27</div>
              </el-descriptions-item-->
            </el-descriptions>
            <div class="score-tips" style="margin-bottom: 10px">
              <div class="tips-title">💡 提示1 : 各个模块评分说明</div>
              <div class="tips-text">
                <span class="tips-bold">1.  基础得分：</span>
                需同时满足以下三个条件，否则基础得分为0。
              </div>
              <div class="tips-text">· 题目内容正确，不存在事实错误。</div>
              <div class="tips-text">· 需符合提交格式，正确填写所有必填项。</div>
              <div class="tips-text">
                · 该题目不与自己过往提交/其他选手提交重复，按提交时间先后顺序，仅最先提交者得分。
              </div>
              <div class="tips-text">
                <span class="tips-bold">2.  解析附加分：</span>
                按照题目解析的正确度、清晰度评分。
              </div>
              <div class="tips-text">
                <span class="tips-bold">3.  质量系数：</span>
                <span class="blue">需综合评估题目和解析的质量。</span>
                由安全专家/自动化评估程序对选手每次提交的题目进行质量评估，将每次提交分类为为“高等质量/中等质量/合格质量”三档，每档对应得分系数，最终得分将综合质量得分系数给出。我们鼓励提供*
                <span class="blue">可追溯，可直接验证题目质量</span>
                *的题目来源，例如具体的教材书，具体的高质量文章/教程url等。对应要求如下：
              </div>
              <div class="tips-text">
                ·
                合格质量（1.0）：题目符合提交格式，不存在事实错误，不与该选手/其他选手提交的其他题目重复。
              </div>
              <div class="tips-text">
                ·
                中等质量（1.2）：题目的逻辑与表述清晰，考察的领域明确，答案明确且不存在歧义，同时提供了清晰合理的解析与可验证的题目来源。
              </div>
              <div class="tips-text">
                ·
                高等质量（1.5）：题目的设计应具有广度/深度/挑战性，从而对不同模型的能力有高区分度。
              </div>
            </div>
            <div class="score-tips" style="margin-bottom: 10px">
              <div class="tips-title">💡 提示2 : 其他提示</div>
              <div class="tips-text">
                <span class="tips-bold">1.  关于可信度判定：</span>
                确保题目的正确性是基本要求和提交者的第一要务。另外每道题目都需要填写其来源（详见提交模板），以保证该题目的可验证性。无效的题目来源会影响质量分的系数。
              </div>
              <div class="tips-text">
                <span class="tips-bold">2.  关于问答题：</span>
                高质量的问答题需要具备考察模型的*理解表达*能力，而*问题太宽泛或者答案太简单*的问答题会影响其质量分加分。我们鼓励选手提交有挑战有深度，有明确具体的考察方向的问答题。
              </div>
            </div>
            <div class="score-tips" style="margin-bottom: 40px">
              <div class="tips-title">💡 提示3 : 参赛锦囊</div>
              <div class="tips-text">
                <span class="tips-bold">
                  【优秀提交案例】SecBench挑战者奖励计划
                  <el-link
                    href="https://docs.qq.com/doc/DY1puaHpWSkRsQ2Fi?_t=1712584793545"
                    target="_blank"
                    style="position: relative; top: -1px"
                  >
                    立即查看
                  </el-link>
                </span>
              </div>
            </div>
          </div>
        </div>
        <!--div id="prize" style="background: #fff">
          <div class="prize">
            <div class="block-title tac">奖项设置</div>
            <div style="font-size: 16px; margin: 35px 0; color: #525c72" class="tac">
              我们将为参赛者提供两种类型的奖励，奖励门槛低，参赛者达到相对应门槛即可获奖，
              <span style="color: #ff3525">可重复获奖！</span>
            </div>
            <div class="prize-block">
              <div class="prize-flag">奖励一：即时奖池</div>
              <div class="prize-div">
                <div class="prize-des">
                  选手积分达到对应的门槛，即可获得对应奖励，不同奖池可重复获奖。
                </div>
                <div class="prize-des" style="margin-bottom: 13px">
                  奖池有上限，以提交时间为准，先达到门槛者获对应奖励，直至奖池瓜分完毕。
                </div>
                <div class="flex" style="justify-content: space-between">
                  <div class="prize-pool">
                    <div class="bold tac" style="margin-top: 22px; margin-bottom: 12px">奖池 1</div>
                    <div class="prize-pool-money">
                      <div style="font-size: 40px; line-height: 1; margin-right: 10px">1000</div>
                      <div>元</div>
                    </div>
                  </div>
                  <div class="prize-pool">
                    <div class="bold tac" style="margin-top: 22px; margin-bottom: 12px">奖池 2</div>
                    <div class="prize-pool-money">
                      <div style="font-size: 40px; line-height: 1; margin-right: 10px">2000</div>
                      <div>元</div>
                    </div>
                  </div>
                  <div class="prize-pool">
                    <div class="bold tac" style="margin-top: 22px; margin-bottom: 12px">奖池 3</div>
                    <div class="prize-pool-money">
                      <div style="font-size: 40px; line-height: 1; margin-right: 10px">3000</div>
                      <div>元</div>
                    </div>
                  </div>
                  <div class="prize-pool">
                    <div class="bold tac" style="margin-top: 22px; margin-bottom: 12px">奖池 4</div>
                    <div class="prize-pool-money">
                      <div style="font-size: 40px; line-height: 1; margin-right: 10px">4000</div>
                      <div>元</div>
                    </div>
                  </div>
                </div>
                <div class="flex" style="justify-content: space-between">
                  <div class="prize-score">
                    <div>积分≥ <span class="orange">150分</span></div>
                    <div>前200名积分达标的选手</div>
                  </div>
                  <div class="prize-score">
                    <div>积分≥ <span class="orange">600分</span></div>
                    <div>前100名积分达标的选手</div>
                  </div>
                  <div class="prize-score">
                    <div>积分≥ <span class="orange">1200分</span></div>
                    <div>前60名积分达标的选手</div>
                  </div>
                  <div class="prize-score">
                    <div>积分≥ <span class="orange">3000分</span></div>
                    <div>前21名积分达标的选手</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="prize-block" style="margin-top: 45px">
              <div class="prize-flag">奖励二：总榜奖励</div>
              <div class="prize-div">
                <div class="prize-des">2024-05-09至 2024-05-11期间公布总榜获奖名单。</div>
                <div style="font-size: 16px; font-weight: 700; margin-top: 17px">总积分排行榜</div>
                <el-table
                  :data="totalTableData"
                  border
                  :span-method="objectSpanMethod"
                  style="width: 100%; margin-top: 15px"
                  header-row-class-name="prize-table-header"
                  cell-class-name="prize-table-cell"
                  row-class-name="prize-table-row"
                  class="prize-table-table"
                >
                  <el-table-column prop="prize" label="奖项" width="180"></el-table-column>
                  <el-table-column prop="detail" label="奖励明细" width="220"></el-table-column>
                  <el-table-column prop="condition" label="获奖条件" width="300"></el-table-column>
                  <el-table-column prop="mark" label="备注"></el-table-column>
                </el-table>
                <div style="font-size: 16px; font-weight: 700; margin-top: 20px">单维度贡献榜</div>
                <el-table
                  :data="dimensionsTableData"
                  border
                  :span-method="dimensionsSpanMethod"
                  style="width: 100%; margin-top: 15px"
                  header-row-class-name="prize-table-header"
                  cell-class-name="prize-table-cell"
                  row-class-name="prize-table-row"
                  class="prize-table-table"
                >
                  <el-table-column prop="prize" label="奖项" width="180"></el-table-column>
                  <el-table-column prop="detail" label="奖励明细" width="220"></el-table-column>
                  <el-table-column prop="condition" label="获奖条件" width="300"></el-table-column>
                  <el-table-column prop="mark" label="备注"></el-table-column>
                </el-table>
                <div style="font-size: 16px; font-weight: 700; margin-top: 20px">最佳星推官</div>
                <el-table
                  :data="recommendTableData"
                  border
                  :span-method="dimensionsSpanMethod"
                  style="width: 100%; margin-top: 15px"
                  header-row-class-name="prize-table-header"
                  cell-class-name="prize-table-cell"
                  row-class-name="prize-table-row"
                  class="prize-table-table"
                >
                  <el-table-column prop="prize" label="奖项" width="180"></el-table-column>
                  <el-table-column prop="detail" label="奖励明细" width="220"></el-table-column>
                  <el-table-column prop="condition" label="获奖条件" width="300"></el-table-column>
                  <el-table-column prop="mark" label="备注"></el-table-column>
                </el-table>
                <div style="font-size: 16px; font-weight: 700; margin-top: 20px">获奖证书</div>
                <el-table
                  :data="certificateTableData"
                  border
                  style="width: 100%; margin-top: 15px"
                  header-row-class-name="prize-table-header"
                  cell-class-name="prize-table-cell"
                  row-class-name="prize-table-row"
                  class="prize-table-table"
                >
                  <el-table-column prop="prize" label="奖项" width="180"></el-table-column>
                  <el-table-column prop="detail" label="奖励明细" width="336"></el-table-column>
                  <el-table-column prop="condition" label="获奖条件"></el-table-column>
                </el-table>
                <div style="font-size: 16px; font-weight: 700; margin-top: 20px">实习机会</div>
                <el-table
                  :data="practiceTableData"
                  border
                  style="width: 100%; margin-top: 15px; margin-bottom: 30px"
                  header-row-class-name="prize-table-header"
                  cell-class-name="prize-table-cell"
                  row-class-name="prize-table-row"
                  class="prize-table-table"
                >
                  <el-table-column prop="prize" label="奖项" width="180"></el-table-column>
                  <el-table-column prop="detail" label="奖励明细"></el-table-column>
                </el-table>
              </div>
            </div>
          </div>
        </div-->
        <div id="rank" class="block-title tac" style="padding: 50px 0">最终排行</div>
        <div class="rank">
          <!--div class="prize-status">
            <div class="status-title">即时奖池动态</div>
            <div class="flex pool-div">
              <div :class="`pool ${poolStatus[0].status}`">
                <div class="pool-content">
                  <div class="tac bold" style="color: #525c72; padding: 19px 0 15px 0">奖池 1</div>
                  <div class="flex pool-prize">
                    <div class="num">1000</div>
                    <div class="num unit">元</div>
                  </div>
                  <div class="pool-line"></div>
                  <div style="margin: 0 27px 20px 27px">
                    <div
                      style="font-size: 16px; color: #525c72; margin-bottom: 8px"
                      :class="poolStatus[0].status === 'pool-doing' ? 'bold' : ''"
                    >
                      {{ poolStatusCn[poolStatus[0].status] }}
                    </div>
                    <el-progress
                      :percentage="
                        poolStatus[0].num === 0
                          ? 0
                          : (poolStatus[0].num / poolStatus[0].total) * 100
                      "
                      :show-text="false"
                      stroke-width="5"
                    ></el-progress>
                  </div>
                </div>
                <div style="font-size: 16px; color: #465262; margin-top: 15px; margin-bottom: 8px">
                  <div>
                    积分≥
                    <span class="orange">150分</span>
                  </div>
                  <div>前200名积分达标的选手</div>
                  <div>获奖金额：¥5/人</div>
                </div>
              </div>
              <div :class="`pool ${poolStatus[1].status}`">
                <div class="pool-content">
                  <div class="tac bold" style="color: #525c72; padding: 19px 0 15px 0">奖池 2</div>
                  <div class="flex pool-prize">
                    <div class="num">2000</div>
                    <div class="num unit">元</div>
                  </div>
                  <div class="pool-line"></div>
                  <div style="margin: 0 27px 20px 27px">
                    <div
                      style="font-size: 16px; color: #525c72; margin-bottom: 8px"
                      :class="poolStatus[1].status === 'pool-doing' ? 'bold' : ''"
                    >
                      {{ poolStatusCn[poolStatus[1].status] }}
                    </div>
                    <el-progress
                      :percentage="
                        poolStatus[1].num === 0
                          ? 0
                          : (poolStatus[1].num / poolStatus[1].total) * 100
                      "
                      :show-text="false"
                      stroke-width="5"
                    ></el-progress>
                  </div>
                </div>
                <div style="font-size: 16px; color: #465262; margin-top: 15px; margin-bottom: 8px">
                  <div>
                    积分≥
                    <span class="orange">600分</span>
                  </div>
                  <div>前100名积分达标的选手</div>
                  <div>获奖金额：¥20/人</div>
                </div>
              </div>
              <div :class="`pool ${poolStatus[2].status}`">
                <div class="pool-content">
                  <div class="tac bold" style="color: #525c72; padding: 19px 0 15px 0">奖池 3</div>
                  <div class="flex pool-prize">
                    <div class="num">3000</div>
                    <div class="num unit">元</div>
                  </div>
                  <div class="pool-line"></div>
                  <div style="margin: 0 27px 20px 27px">
                    <div
                      style="font-size: 16px; color: #525c72; margin-bottom: 8px"
                      :class="poolStatus[2].status === 'pool-doing' ? 'bold' : ''"
                    >
                      {{ poolStatusCn[poolStatus[2].status] }}
                    </div>
                    <el-progress
                      :percentage="
                        poolStatus[2].num === 0
                          ? 0
                          : (poolStatus[2].num / poolStatus[2].total) * 100
                      "
                      :show-text="false"
                      stroke-width="5"
                    ></el-progress>
                  </div>
                </div>
                <div style="font-size: 16px; color: #465262; margin-top: 15px; margin-bottom: 8px">
                  <div>
                    积分≥
                    <span class="orange">1200分</span>
                  </div>
                  <div>前60名积分达标的选手</div>
                  <div>获奖金额：¥50/人</div>
                </div>
              </div>
              <div :class="`pool ${poolStatus[3].status}`">
                <div class="pool-content">
                  <div class="tac bold" style="color: #525c72; padding: 19px 0 15px 0">奖池 4</div>
                  <div class="flex pool-prize">
                    <div class="num">4000</div>
                    <div class="num unit">元</div>
                  </div>
                  <div class="pool-line"></div>
                  <div style="margin: 0 27px 20px 27px">
                    <div
                      style="font-size: 16px; color: #525c72; margin-bottom: 8px"
                      :class="poolStatus[3].status === 'pool-doing' ? 'bold' : ''"
                    >
                      {{ poolStatusCn[poolStatus[3].status] }}
                    </div>
                    <el-progress
                      :percentage="
                        poolStatus[3].num === 0
                          ? 0
                          : (poolStatus[3].num / poolStatus[3].total) * 100
                      "
                      :show-text="false"
                      stroke-width="5"
                    ></el-progress>
                  </div>
                </div>
                <div style="font-size: 16px; color: #465262; margin-top: 15px; margin-bottom: 8px">
                  <div>
                    积分≥
                    <span class="orange">3000分</span>
                  </div>
                  <div>前21名积分达标的选手</div>
                  <div>获奖金额：¥200/人</div>
                </div>
              </div>
            </div>
          </div-->
          <div class="rank-list">
            <div class="flex" style="justify-content: space-between; margin-bottom: 10px">
              <div style="color: #175bd9; font-size: 12px; line-height: 30px">
                <i class="el-icon-warning-outline"></i>
                开奖前将进行官方数据集追溯，最终数据以获奖公布为准。
              </div>
              <el-input
                placeholder="输入参赛者ID检索"
                suffix-icon="el-icon-search"
                v-model="search"
                size="small"
                style="width: 289px"
                @keyup.enter.native="submit"
                clearable
              >
              </el-input>
            </div>
            <el-table :data="data" style="width: 100%" class="rank-table">
              <el-table-column label="排序" width="72">
                <template slot-scope="scope">
                  {{ scope.row.rank }}
                </template>
              </el-table-column>
              <el-table-column prop="user_id" label="参赛者ID" width="290"></el-table-column>
              <el-table-column prop="school_name" label="学校" width="245"></el-table-column>
              <el-table-column prop="score" label="积分" width="187"></el-table-column>
              <el-table-column prop="prize_pool" label="获得奖励">
                <template slot-scope="scope">
                  <div class="flex">
                    <div
                      v-for="(item, idx) in scope.row.prize"
                      :key="idx"
                      :class="`prize-item flex prize-icon-${idx + 1}${item === 0 ? '-grey' : ''}`"
                    >
                      <div class="prize-icon"></div>
                      <div>奖池{{ idx + 1 }}</div>
                    </div>
                  </div>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination
              class="pagination"
              background
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[10, 20, 30, 50, 100, 200]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
            >
            </el-pagination>
          </div>
        </div>
        <page-footer></page-footer>
      </div>
    </div>
    <el-dialog :title="curDataset.dataset_name" :visible.sync="datasetVisible" width="30%">
      <json-viewer :value="{ data: curDataset.data_example }" :expand-depth="5" copyable>
      </json-viewer>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="datasetVisible = false" size="small" class="dataset-btn">
          关闭
        </el-button>
      </span>
    </el-dialog>
    <el-backtop v-show="showToTop" target=".second" visibility-height="0"></el-backtop>
  </div>
</template>

<script>
import PageFooter from '@/components/Footer';
import { doHttp } from '@/common/simple_http';
import JsonViewer from 'vue-json-viewer';

const poolStatus = [
  {
    num: 0,
    total: 200,
    status: 'pool-finish',
  },
  {
    num: 0,
    total: 100,
    status: 'pool-finish',
  },
  {
    num: 0,
    total: 60,
    status: 'pool-doing',
  },
  {
    num: 0,
    total: 21,
    status: 'pool-unstart',
  },
];

const practiceTableData = [
  {
    prize: '实习机会',
    detail: '有机会开启面试流程，加入鹅厂实习',
  },
];

const certificateTableData = [
  {
    prize: '获奖证书',
    detail: 'SecBench平台电子证书',
    condition: 'TOP50',
  },
];

const recommendTableData = [
  {
    prize: '第 1 名',
    detail: '京东卡 500 元',
    condition: '累计邀约参赛人数第1，且≥15人',
    mark: '以被推荐者在报名问卷中正确填写推荐者邮箱为准，且被推荐者需获得有效成绩',
  },
  {
    prize: '第 2 名',
    detail: '京东卡 300 元',
    condition: '累计邀约参赛人数第2，且≥15人',
  },
  {
    prize: '第 3 名',
    detail: '京东卡 200 元',
    condition: '累计邀约参赛人数第3，且≥10人',
  },
];

const dimensionsTableData = [
  {
    prize: '第 1 名',
    detail: '京东卡 500 元',
    condition: '累计积分排行第1名',
    mark: '仅针对以下3个维度设置：端点与主机安全方向、应用安全方向、安全标准与法规方向',
  },
  {
    prize: '第 2 名',
    detail: '京东卡 300 元',
    condition: '累计积分排行第2名',
  },
  {
    prize: '第 3 名',
    detail: '京东卡 200 元',
    condition: '累计积分排行第3名',
  },
];

const totalTableData = [
  {
    prize: '第 1 名',
    detail: '京东卡 6000 元',
    condition: '累计积分排行第1名，且>=10000',
    mark: '若积分要求未达到门槛，则按照对应积分门槛的奖励发放',
  },
  {
    prize: '第 2 名',
    detail: '京东卡 5000 元',
    condition: '累计积分排行第2名，且>=9000',
  },
  {
    prize: '第 3 名',
    detail: '京东卡 3000 元',
    condition: '累计积分排行第3名，且>=8000',
  },
  {
    prize: '第 4-5 名',
    detail: '京东卡 2000 元',
    condition: '累计积分排行第4-5名，且>=6000',
  },
  {
    prize: '第 6-10 名',
    detail: '京东卡 1000 元',
    condition: '累计积分排行第6-10名，且>=3000',
  },
  {
    prize: 'TOP 30',
    detail: '生肖公仔',
    condition: '累计积分排行TOP30名，且>=500',
  },
];

export default {
  components: {
    PageFooter,
    JsonViewer,
  },
  data() {
    return {
      activeBlock: 1,
      totalTableData,
      dimensionsTableData,
      recommendTableData,
      certificateTableData,
      practiceTableData,
      poolStatus,
      poolStatusCn: {
        'pool-finish': '已告罄',
        'pool-unstart': '待开启',
        'pool-doing': '冲击中...',
      },
      showToTop: false,
      search: '',
      fullData: [],
      data: [],
      currentPage: 1,
      pageSize: 20,
      total: 0,
      curDataset: {},
      datasetVisible: false,
      contributors: [],
    };
  },
  created: function () {
    this.getData();
    // this.getContributor();
  },
  mounted() {
    // 判断手机端
    if (/Mobi|Android|iPhone/i.test(navigator.userAgent)) {
      const height = document.getElementById('banner').getBoundingClientRect().height;
      document.getElementById('nav').setAttribute('style', `top: calc(${height}px - 60px)`);
    }
  },
  methods: {
    scrollToSecond(event) {
      if (event.deltaY > 0) {
        // 滚动到下一屏
        this.$refs.container.setAttribute(
          'style',
          'width: 100%; height: 100%;transition: transform 400ms ease-in-out 0s; outline: none; transform: translate3d(0px, calc(-100% + 108px), 0px);'
        );
        this.showToTop = true;
      }
    },
    scrollToFirst(e) {
      if (e.deltaY < 0 && this.$refs.second.scrollTop === 0) {
        this.$refs.container.setAttribute(
          'style',
          'width: 100%; height: 100%;transition: transform 400ms ease-in-out 0s; outline: none; transform: translate3d(0px, 0%, 0px);'
        );
        this.showToTop = false;
      }
    },
    changeBlock(block) {
      this.$refs.container.setAttribute(
        'style',
        'width: 100%; height: 100%;transition: transform 400ms ease-in-out 0s; outline: none; transform: translate3d(0px, calc(-100% + 108px), 0px);'
      );
      this.activeBlock = block;
      const parentOffset = document.getElementById('second').offsetTop;
      const ids = ['', 'about', 'explanation', 'schedule', 'range', 'prize', 'rank'];
      document
        .getElementById('second')
        .scrollTo(0, document.getElementById(ids[block]).offsetTop - parentOffset);
      this.showToTop = true;
    },
    objectSpanMethod({ rowIndex, columnIndex }) {
      if (columnIndex === 3) {
        if (rowIndex === 0) {
          return {
            rowspan: 6,
            colspan: 1,
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0,
          };
        }
      }
    },
    dimensionsSpanMethod({ rowIndex, columnIndex }) {
      if (columnIndex === 3) {
        if (rowIndex === 0) {
          return {
            rowspan: 3,
            colspan: 1,
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0,
          };
        }
      }
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      this.data = this.fullData.slice(0, this.currentPage * this.pageSize);
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.data = this.fullData.slice(
        (this.currentPage - 1) * this.pageSize,
        this.currentPage * this.pageSize
      );
    },
    submit() {
      // 搜索
      this.currentPage = 1;
      this.data = this.fullData.filter((item) => {
        return item.user_id.indexOf(this.search) > -1;
      });
    },
    getData() {
      doHttp('/data/getOtherInfo', 'post', { group: 'leaderboard_infos' }, (rst) => {
        rst.data.sort((n1, n2) => {
          return parseInt(n2.score) - parseInt(n1.score);
        });
        this.total = rst.data.length;
        this.fullData = rst.data.map((row, index) => {
          row.prize = [0, 0, 0, 0];
          row.prize.map((item, idx) => {
            if (row.prize_pool.indexOf((idx + 1).toString()) > -1) {
              row.prize[idx] = 1;
              this.poolStatus[idx].num += 1;
            }
          });
          row.rank = index + 1;
          return row;
        });
        this.data = this.fullData.slice(0, this.pageSize);
        this.poolStatus.map((item) => {
          if (item.num === 0) {
            item.status = 'pool-unstart';
          } else if (item.num < item.total) {
            item.status = 'pool-doing';
          } else {
            item.status = 'pool-finish';
          }
        });
      });
    },
    openDataset(idx) {
      this.curDataset = this.dataset[idx];
      this.datasetVisible = true;
    },
    jumpToBoard() {
      this.$router.push({
        path: `/board`,
      });
    },
    getContributor() {
      doHttp('/data/getContributor', 'post', {}, (rst) => {
        let { contributors } = this;
        contributors = rst.data
          .sort((n1, n2) => {
            return n2.score - n1.score;
          })
          .slice(0, 3);
        [contributors[0], contributors[1]] = [contributors[1], contributors[0]];
        this.contributors = contributors;
      });
    },
  },
};
</script>

<style lang="less" scoped>
@import '~@/assets/styles/_var.less';
@import '~@/assets/styles/_mixin.less';

/deep/.el-descriptions :not(.is-bordered) .el-descriptions-item__cell {
  padding-bottom: 20px;
}

/deep/.el-descriptions .is-bordered .el-descriptions-item__cell {
  padding: 20px;
}
/deep/.is-bordered-label {
  padding: 10px 20px !important;
}

.el-backtop {
  color: #005aff;
}
.footer {
  height: 180px;
}

.orange {
  color: #ff3525;
}

.bold {
  font-weight: 700;
}
/deep/.el-input__inner {
  border-radius: 0;
}
/deep/.el-descriptions-item__label {
  &:first-of-type {
    width: 570px;
  }
}
.pagination {
  text-align: right;
  margin-top: 10px;
}

.f16 {
  font-size: 16px;
}
/deep/.el-descriptions-item__label.is-bordered-label {
  color: #000;
  font-size: 12px;
}
ul {
  padding-inline-start: 1em;
  margin-block-start: 0;
  margin-block-end: 0;
}

.tips {
  color: rgb(82, 92, 114);
}
.blue {
  color: #005aff;
}

.hr {
  margin: 26px 0;
  border-bottom: 2px solid #fff;
  width: 100%;
}

.rank-table {
  font-family: PingFang SC;
  color: #444;
  /deep/th {
    font-weight: 600;
    background: #f9f9fb;
  }
  /deep/thead {
    color: #888;
  }
  /deep/.cell {
    padding-left: 18px !important;
    padding-right: 18px !important;
  }
  .prize-item {
    height: 20px;
    background: #fee5dd;
    font-size: 12px;
    line-height: 20px;
    margin-right: 10px;
    padding: 0 5px;
    color: #ff3525;
    .prize-icon {
      width: 16px;
      height: 16px;
      background-image: url(~@/assets/images/prize-1.png);
      background-repeat: no-repeat;
      background-size: contain;
      margin-top: 2px;
      margin-right: 4px;
    }
  }
  .prize-icon-1 {
    .prize-icon {
      background-image: url(~@/assets/images/prize-1.png);
    }
  }
  .prize-icon-2 {
    .prize-icon {
      background-image: url(~@/assets/images/prize-2.png);
    }
  }
  .prize-icon-3 {
    .prize-icon {
      background-image: url(~@/assets/images/prize-3.png);
    }
  }
  .prize-icon-4 {
    .prize-icon {
      background-image: url(~@/assets/images/prize-4.png);
    }
  }
  .prize-icon-1-grey {
    .prize-icon {
      background-image: url(~@/assets/images/prize-1-grey.png);
    }
    color: #8e9398;
    background: #f5f5f5;
  }
  .prize-icon-2-grey {
    .prize-icon {
      background-image: url(~@/assets/images/prize-2-grey.png);
    }
    color: #8e9398;
    background: #f5f5f5;
  }
  .prize-icon-3-grey {
    .prize-icon {
      background-image: url(~@/assets/images/prize-3-grey.png);
    }
    color: #8e9398;
    background: #f5f5f5;
  }
  .prize-icon-4-grey {
    .prize-icon {
      background-image: url(~@/assets/images/prize-4-grey.png);
    }
    color: #8e9398;
    background: #f5f5f5;
  }
}

/deep/ .el-progress-bar__inner {
  background: linear-gradient(90deg, #ff9d34 0%, #fd5132 100%);
  border-radius: 0;
}
/deep/.el-progress-bar__outer {
  background-color: #f5f5f5 !important;
  border-radius: 0;
}

/deep/.el-badge__content.is-fixed {
  background: #ff3525;
  padding: 0 6px;
  border-radius: 2px;
  font-size: 12px;
  line-height: 20px;
  top: 30px;
  left: 25px;
  width: 37px;
  height: 20px;
}

/deep/.prize-table-header {
  th {
    background: #ffd7ce;
    border-bottom: 1px solid #eaa596 !important;
    border-right: 1px solid #eaa596 !important;
    .cell {
      font-size: 12px;
      font-weight: 400;
      color: #000;
      padding-left: 20px !important;
    }
  }
}

/deep/.prize-table-cell {
  border-bottom: 1px solid #eaa596 !important;
  border-right: 1px solid #eaa596 !important;
  color: #525c72;
  font-size: 12px;
  padding-left: 10px;
  background: #fff !important;
}
/deep/.prize-table-table {
  border: 1px solid #eaa596 !important;
}

.prize {
  padding: 48px 0;
  width: @width;
  margin: auto;
  .prize-block {
    border: 1px solid rgba(234, 94, 64, 0.23);
    background: linear-gradient(180deg, rgba(253, 81, 50, 0.09) 0%, rgba(253, 81, 50, 0) 55%);
    width: 100%;
    .prize-flag {
      width: 234px;
      height: 60px;
      line-height: 60px;
      color: #fff;
      padding-left: 24px;
      font-size: 18px;
      font-weight: 700;
      margin-top: -5px;
      background-image: url(~@/assets/images/prize_name_bg.png);
      background-size: contain;
      background-repeat: no-repeat;
    }
    .prize-div {
      padding: 20px 32px;
      .prize-des {
        color: #ff3525;
      }
      .prize-pool {
        box-shadow: 0px 8px 20px 0px rgba(234, 94, 64, 0.12),
          0px -2px 20px 0px rgba(234, 94, 64, 0.02);
        width: 264px;
        height: 128px;
        background-image: url(~@/assets/images/money.png);
        background-size: 84px;
        background-position: 18px 20px;
        background-repeat: no-repeat;
        .prize-pool-money {
          color: #ff3525;
          font-size: 20px;
          font-weight: 700;
          font-family: 'TCloud Number';
          display: flex;
          text-align: center;
          .align-items(flex-end);
          .justify-content(center);
        }
      }
      .prize-score {
        font-size: 16px;
        width: 264px;
        margin-top: 20px;
        margin-bottom: 10px;
        color: #465262;
      }
    }
  }
}

.score-tips {
  background: linear-gradient(272.95deg, rgba(233, 242, 255, 0) -10.57%, #d5e6ff 131.53%);
  padding: 20px;
  .tips-title {
    font-weight: 700;
  }
  .tips-text {
    font-size: 12px;
    color: #525c72;
    line-height: 20px;
    font-family: PingFang SC;
    margin-top: 10px;
    .tips-bold {
      font-weight: 600;
      /deep/.el-link--inner {
        font-size: 12px;
      }
    }
  }
}

.container {
  width: 100%;
  height: 100vh;
  overflow: hidden;
  .first,
  .second {
    width: 100%;
    height: 100%;
    overflow: auto;
  }
}
.el-button--primary {
  background-color: @color-primary;
  border-color: @color-primary;
}
.block-title {
  font-size: 28px;
  font-weight: 700;
  line-height: 42px;
  font-family: TencentSans;
  text-align: center;
  // padding: 0 0 40px 0;
}
.banner-text {
  line-height: 22px;
  color: rgba(82, 92, 114, 0.9);
  font-weight: 400;
  max-width: 780px;
  font-family: Source Han Sans CN;
  margin-top: 25px;
}
.banner-main-info {
  font-weight: 400x;
}

.banner {
  background: url(https://secbench-1258476245.cos.ap-guangzhou.myqcloud.com/secbench/challenge_bg.png)
      center 23px / auto 100% no-repeat,
    #eef2f6;
  width: 100%;
  height: 100vh;
  .align-items();
  .justify-content(center);
  .banner-content {
    width: @width;
    .banner-title {
      color: @color-primary;
      font-size: 40px;
      line-height: 60px;
      margin-top: 20px;
      font-family: TencentSans;
      font-weight: 700;
    }
    .banner-title-orange {
      color: rgb(234, 94, 64);
    }
    .banner-prize {
      border-left: 4px solid rgb(0, 90, 255);
      background: linear-gradient(90deg, rgba(0, 92, 255, 0.08) 0%, rgba(0, 92, 255, 0) 100%);
      width: 579px;
      height: 83px;
      margin-top: 25px;
      padding-left: 17px;
      padding-top: 10px;
      .banner-prize-main {
        color: @color-primary;
        font-size: 24px;
        line-height: 36px;
        font-weight: 700;
      }
      .banner-prize-tips {
        color: @color-primary;
        font-size: 18px;
        line-height: 27px;
        font-weight: 400;
      }
    }
    .el-link .is-underline :hover :after,
    .el-link .is-underline :visited :after {
      content: none;
    }
    .banner-btn {
      margin-top: 40px;
      background: #ff3525;
      box-shadow: 0px 4px 4px 0px rgba(234, 94, 64, 0.1);
      color: #fff;
      width: 150px;
      span {
        font-weight: 700;
      }
    }
  }
  .slogan {
    color: #000;
    font-size: 20px;
    font-weight: 700;
    font-family: TencentSans;
    line-height: 30px;
    margin-top: 10px;
  }
}

.nav {
  width: 100%;
  height: 60px;
  background: rgba(255, 255, 255, 0.28);
  position: fixed;
  top: calc(100% - 60px);
  & > div {
    margin: auto;
    display: flex;
    width: @width;
    height: 100%;
    .nav-item {
      cursor: pointer;
      width: 100%;
      height: 100%;
      text-align: center;
      line-height: 60px;
      font-size: 18px;
      font-weight: 400;
      &:first-of-type {
        border-left: 1px solid #fff;
      }
      border-right: 1px solid #fff;
      &:hover {
        background: linear-gradient(
          54.68deg,
          rgba(255, 255, 255, 0.24) -12.87%,
          rgba(242, 247, 255, 0.8) 53.56%
        );
      }
      &.active {
        background: linear-gradient(0deg, #fff 0%, rgba(255, 255, 255, 0) 132.5%);
        color: #ff3525;
        border-right: 0;
        border-left: 0;
        border-bottom: 3px solid #ff3525;
      }
    }
  }
}

.advantage {
  background: #fff;
  width: 100%;
  height: calc(100vh - 400px);
  .align-items();
  max-height: calc(100vh / 2);
  & > div {
    margin: auto;
  }
}
.advantage-div {
  .justify-content(space-between);
  width: @width;
  margin: auto;
  .advantage-content {
    width: 380px;
    height: 150px;
    padding: 20px;
    background: linear-gradient(180deg, #f2f3f6 0%, rgba(242, 243, 246, 0) 54.93%);
    border: 1px solid rgba(243, 244, 246, 1);
    .advantage-img {
      width: 84px;
      height: 84px;
      background-size: contain;
      background-repeat: no-repeat;
      &.advantage-img-1 {
        background-image: url(../../assets/images/advantage_1.png);
      }
      &.advantage-img-2 {
        background-image: url(../../assets/images/advantage_2.png);
      }
      &.advantage-img-3 {
        background-image: url(../../assets/images/advantage_3.png);
      }
    }
    .advantage-content-div {
      padding: 0 10px;
      width: calc(100% - 84px);
      .advantage-text {
        color: #848c9b;
        line-height: 20px;
        padding-top: 8px;
      }
    }
    .advantage-sub-title {
      font-size: 16px;
      font-weight: 700;
      line-height: 24px;
      color: #252831;
    }
  }
}
.width {
  width: @width;
}
.dataset-text {
  max-width: @width;
}
.dataset-img {
  width: @width;
  height: 644px;
  background-image: url(https://secbench-1258476245.cos.ap-guangzhou.myqcloud.com/secbench/banner.png);
  background-size: 744px 553px;
  background-repeat: no-repeat;
  background-position: 50%;
  margin: 20px auto 20px auto;
  border: 2px solid #fff;
  background-color: linear-gradient(181.48deg, #f3f5f8 -3.38%, #fff 37.6%),
    linear-gradient(0deg, #fff, #fff);
  box-shadow: -8px -8px 20px 0px rgba(255, 255, 255, 0.6), 8px 8px 20px 0px rgba(55, 99, 170, 0.1);
  background: url(../../assets/images/dataset.png) center center / 744px 553px no-repeat,
    linear-gradient(181.48deg, #f3f5f8 -3.38%, #fff 37.6%), linear-gradient(0deg, #fff, #fff);
}
.qrcode {
  margin-left: 50px;
  .qrcode-div {
    border: 4px solid #dfe1e4;
    width: 148px;
    height: 148px;
    border-radius: 7px;
    background-image: url(~@/assets/images/qqqun.png);
    background-repeat: no-repeat;
    background-position: center center;
    background-size: 98%;
    margin-bottom: 10px;
  }
  &.qrcode-footer {
    margin-left: 75px;
    font-weight: 400;
    .qrcode-div {
      width: 100px;
      height: 100px;
      border: none;
    }
    .qrcode-tips {
      color: rgba(255, 255, 255, 0.4);
      line-height: 1.5;
    }
  }
  &:first-of-type {
    margin-left: 0px;
  }
  .qrcode-div-haohao {
    background-image: url(~@/assets/images/haohao.png);
  }
  .qrcode-div-zona {
    background-image: url(~@/assets/images/zona.png);
  }
}
.dataset-list {
  width: @width;
  flex-wrap: wrap;
  margin-top: 50px;
  box-shadow: -8px -8px 20px 0px rgba(255, 255, 255, 1), 8px 8px 20px 0px rgba(55, 99, 170, 0.1) !important;
  border: 2px solid rgba(255, 255, 255, 1) !important;
  background: linear-gradient(180deg, #f3f5f8 0%, #fff 100%) !important;
  /deep/.el-link--inner {
    color: rgb(0, 90, 255);
  }

  .rule-title-text {
    width: 92px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    background: #005cff;
    color: #fff;
    font-size: 18px;
    font-weight: 700;
    padding-left: 8px;
  }
  .mid {
    width: 20px;
    height: 40px;
    left: 122px;
    top: 80px;
    background: #005cff;
    transform: matrix(1, 0, 0, -1, 0, 0);
    transform: skewX(165deg);
    margin-left: -5px;
  }
  .rectangle {
    width: 124px;
    height: 40px;
    left: 132px;
    top: 80px;
    background: linear-gradient(270deg, rgba(0, 92, 255, 0) 0%, #005cff 100%);
    opacity: 0.16;
    transform: matrix(1, 0, 0, -1, 0, 0);
    margin-left: -10px;
  }
  .rule-des-title {
    font-size: 16px;
    font-weight: 700;
    line-height: 32px;
    margin-top: 10px;
    margin-bottom: 10px;
    &.range-div {
      margin-top: 0;
      margin-bottom: 4px;
    }
    /deep/.el-link--inner {
      color: rgb(0, 90, 255);
      font-size: 16px;
      font-weight: 700;
      line-height: 32px;
    }
    .plain-title {
      font-weight: 400;
      color: #525c72;
      width: 100px;
      line-height: 24px;
      margin-top: 9px;
    }
    .range {
      width: calc(100% - 85px);
      line-height: 24px;
      margin-top: 9px;
      font-weight: 400;
    }
  }
  .time {
    border: 1px solid #ff3525;
    width: 356px;
    height: 32px;
    border-radius: 1px 0px 0px 0px;
    margin-left: 32px;
    margin-bottom: 20px;
    .time-main {
      background: #ff3525;
      text-align: center;
      line-height: 32px;
      color: #fff;
      width: 96px;
    }
    .time-info {
      padding-left: 13px;
      line-height: 32px;
    }
  }
  .step {
    background: linear-gradient(90deg, #e9f2ff 0%, #d5e6ff 100%);
    width: 257px;
    height: 48px;
    z-index: 2;
  }
  .step-triangle {
    width: 0;
    height: 0;
    border-left: 24px solid #d5e6ff;
    border-top: 24px solid transparent;
    border-bottom: 24px solid transparent;
    z-index: 2;
  }
  .step-triangle-1 {
    width: 41px;
    height: 38px;
    background: linear-gradient(270deg, #005cff 0%, rgba(0, 92, 255, 0) 121.95%);
    margin-top: 5px;
    margin-left: -52px;
  }
  .step-triangle-2 {
    width: 0;
    height: 0;
    border-left: 19px solid #005cff;
    border-top: 19px solid transparent;
    border-bottom: 19px solid transparent;
    margin-top: 5px;
  }
  .step-triangle-3 {
    width: 0;
    height: 0;
    border-left: 24px solid #fff;
    border-top: 24px solid transparent;
    border-bottom: 24px solid transparent;
    z-index: 3;
  }
  .flow-content {
    .justify-content(space-between);
    .flow-info {
      background: linear-gradient(357.07deg, rgba(233, 242, 255, 0) -13.81%, #d5e6ff 127.48%);
      width: 255px;
      height: 271px;
      padding: 20px 16px;
      li {
        padding-bottom: 15px;
      }
      .el-button {
        color: rgb(0, 90, 255);
      }
    }
  }
}
.schedule {
  background: #fff;
  padding: 48px 0 60px 0;
  width: @width;
  margin: auto;
  .schedule-div {
    .justify-content(space-between);
    color: #525c72;
    & > div {
      width: 380px;
      text-align: center;
    }
    &.schedule-title {
      margin-top: 15px;
      & > div {
        font-size: 16px;
        font-weight: 700;
        line-height: 60px;
        text-align: center;
        color: #000;
      }
    }
    .schedule-info {
      font-family: PingFang SC;
      width: 380px;
      height: 174px;
      padding: 20px 24px 0 24px;
      border: 1px solid #f3f4f6;
      text-align: left;
      margin-top: 24px;
      background: linear-gradient(180deg, #f3f4f6 0%, rgba(242, 243, 246, 0) 54.93%);
    }
  }
  .stage {
    width: 100%;
    height: 22px;
    margin-top: 12px;
    .stage-0 {
      background: linear-gradient(270deg, #005cff 0%, rgba(0, 92, 255, 0) 100%);
      width: 167px;
      height: 1px;
    }
    .stage-1 {
      width: 22px;
      height: 22px;
      background: rgba(0, 90, 255, 0.1);
      margin: -11px 10px;
      transform: rotate(45deg);
      .stage-1-inside {
        width: 12px;
        height: 12px;
        background: #005aff;
        margin-top: 5px;
        margin-left: 5px;
      }
    }
    .stage-2 {
      background: #005aff;
      width: 354px;
      height: 1px;
    }
    .stage-4 {
      background: linear-gradient(270deg, rgba(0, 92, 255, 0) 0%, #005cff 100%);
      width: 167px;
      height: 1px;
    }
  }
}

.schedule-info-title {
  font-size: 16px;
  color: #525c72;
  font-weight: 600;
  line-height: 22px;
  margin-bottom: 15px;
}
.schedule-info-text {
  font-size: 12px;
  color: #525c72;
  line-height: 17px;
  margin-bottom: 9px;
}
.range-detail {
  .schedule-info-title {
    margin-bottom: 5px;
  }
  .schedule-info-text {
    margin-bottom: 5px;
    opacity: 0.8;
  }
  margin-left: 60px;
  &:first-of-type {
    margin-left: 0;
  }
}
.tag {
  background: rgb(219, 232, 255);
  padding: 0 8px;
  border: none;
  border-radius: 0;
  color: @color-primary;
  height: 20px;
  line-height: 20px;
}
.dataset-tips {
  color: #aaa;
  line-height: 20px;
}
.dataset-divider {
  padding: 0 10px;
}
.show-data {
  color: @color-primary;
  line-height: 20px;
  cursor: pointer;
}
.dataset-info {
  .justify-content(space-between);
  padding: 20px 0 10px 0;
}
/deep/.dataset-des {
  button {
    width: 100%;
    text-align: left;
    span {
      color: #848c9b;
      font-weight: 400;
      width: 100%;
      display: -webkit-box;
      height: 66px;
      line-height: 22px;
      overflow: hidden;
      white-space: normal !important;
      word-break: break-all;
      text-overflow: ellipsis;
      word-wrap: break-word;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
    }
  }
}
.cooperate {
  background: transparent;
  // margin-top: 50px;
  padding: 50px 0;
  height: auto;
  max-height: none;
  .block-title {
    padding-bottom: 50px;
  }
}
.cooperate-div {
  .justify-content(space-between);
  .advantage-content {
    box-shadow: 0px 8px 20px 0px rgba(55, 99, 170, 0.12), 0px -2px 20px 0px rgba(55, 99, 170, 0.02);
    background: #fff;
    border: none;
    height: 182px;
    width: 151px;
    // .align-items;
    .justify-content(center);
  }
  .cooperate-main-text {
    font-size: 16px;
    color: rgb(37, 40, 49);
    padding-top: 20px;
    text-align: center;
  }
  .cooperate-text {
    font-size: 14px;
    line-height: 20px;
    height: 20px;
    font-weight: 400;
    color: rgb(132, 140, 155);
    text-align: center;
  }
  .cooperate-img {
    background-size: contain;
    background-repeat: no-repeat;
    margin: auto;
  }
  .cooperate-img-1 {
    width: 84px;
    height: 84px;
    background-image: url(../../assets/images/challenge_co_1.png);
  }
  .cooperate-img-2 {
    width: 88px;
    height: 84px;
    background-image: url(../../assets/images/challenge_co_2.png);
    background-size: 88px 69px;
    background-position-y: 50%;
  }
  .cooperate-img-3 {
    width: 84px;
    height: 84px;
    background-image: url(../../assets/images/challenge_co_3.png);
  }
  .cooperate-img-4 {
    width: 84px;
    height: 84px;
    background-image: url(../../assets/images/challenge_co_4.png);
  }
  .cooperate-img-5 {
    width: 84px;
    height: 84px;
    background-image: url(../../assets/images/challenge_co_5.png);
  }
  .cooperate-img-6 {
    width: 124px;
    height: 91px;
    background-image: url(../../assets/images/challenge_co_6.png);
  }
  .cooperate-img-7 {
    width: 66px;
    height: 68px;
    background-image: url(../../assets/images/challenge_co_7.png);
  }
}
.rank {
  width: @width;
  margin: auto;
  .prize-status {
    height: 365px;
    padding: 15px 32px;
    margin-top: 40px;
    margin-bottom: 30px;
    background: linear-gradient(180deg, rgba(253, 81, 50, 0.09) 0%, rgba(253, 81, 50, 0) 55%), #fff;
    border: 2px solid #fff;
    box-shadow: -8px -8px 20px 0px rgba(255, 255, 255, 0.4), 8px 8px 20px 0px rgba(55, 99, 170, 0.1);
    width: 100%;
    .status-title {
      color: #ff3525;
      font-size: 20px;
      font-weight: 700;
      line-height: 24px;
    }
    .pool-div {
      .justify-content(space-between);
      margin: 17px 0;
      .pool {
        width: 264px;
        height: 200px;
        .tips {
          color: #525c72;
          font-size: 16px;
        }
        .num {
          color: #ff3525;
          font-family: TCloud Number;
          font-size: 40px;
          font-weight: 700;
          line-height: 32px;
        }
        .unit {
          font-size: 20px;
          line-height: 1;
          margin-left: 10px;
        }
        .pool-line {
          background: #fce6e1;
          width: 224px;
          height: 1px;
          margin: 30px auto 17px auto;
        }
        .pool-prize {
          .justify-content(center);
          .align-items(flex-end);
        }
        .pool-content {
          border: 1px solid #f2e4e1;
          background-image: url(~@/assets/images/money-grey.png);
          background-size: 84px;
          background-position: 10px 20px;
          background-repeat: no-repeat;
          background-color: #fff;
        }
        &.pool-doing {
          .pool-content {
            box-shadow: 0px 8px 20px 0px rgba(234, 94, 64, 0.12),
              0px -2px 20px 0px rgba(234, 94, 64, 0.02);
            border: none;
            background-image: url(~@/assets/images/money-red.png);
            height: 190px;
          }
        }
        &.pool-unstart {
          .pool-content {
            background-image: url(~@/assets/images/money-red.png);
          }
        }
        &.pool-finish {
          .num {
            color: #b6b6b6;
          }
        }
      }
    }
  }
}
.rank-list {
  border: 2px solid #fff;
  box-shadow: -8px -8px 20px 0px rgba(255, 255, 255, 0.6), 8px 8px 20px 0px rgba(55, 99, 170, 0.1);
  background: #fff;
  width: 100%;
  padding: 24px 20px;
  margin-bottom: 58px;
}
.connect-content {
  background: #242933;
  .connect {
    font-size: 28px;
    line-height: 42px;
    font-weight: 700;
    color: #fff;
    font-family: TencentSans;
    margin: auto;
    width: @width;
    height: 100%;
    padding: 40px 0;
    .connect-plain-title {
      font-family: Source Han Sans CN;
      font-size: 18px;
      font-weight: 400;
      line-height: 20px;
      opacity: 0.6;
      margin-top: 10px;
    }
  }
}
.dataset-btn {
  width: 88px;
}
.more-dataset {
  color: @color-primary;
  font-size: 16px;
  line-height: 22px;
  .el-link.el-link--primary {
    font-size: 16px;
  }
}
/deep/.el-dialog__footer {
  text-align: center;
}
.contributor {
  max-height: 560px !important;
  height: 560px !important;
  margin-top: 50px;
  background: #fff;
  padding: 50px;
  & > div {
    height: 400px;
    .contributor-div {
      width: 850px;
      margin: auto;
      margin-top: 20px;
      .justify-content(space-between);
      & > div {
        &:hover {
          transform: scale(1.05);
        }
        transition: transform 1s ease 0s, -webkit-transform 1s ease 0s;
        width: 250px;
        height: 270px;
        box-shadow: -8px -8px 20px 0px rgba(255, 255, 255, 0.6),
          8px 8px 20px 0px rgba(55, 99, 170, 0.1);
        border-radius: 20px;
        border: 2px solid #fff;
        background: linear-gradient(180deg, #f3f5f8 0%, #fff 100%);
        background: linear-gradient(181.48deg, #f3f5f8 -3.38%, #fff 37.6%),
          linear-gradient(0deg, #fff, #fff);
        &:nth-of-type(2) {
          height: 300px;
        }
        & > div {
          text-align: center;
        }
        .avator {
          width: 115px;
          height: 115px;
          margin: 45px auto auto auto;
          border-radius: 50%;
          & > div {
            width: 100px;
            height: 100px;
            background-size: contain;
            background-repeat: no-repeat;
            border-radius: 50%;
            margin: auto;
          }
          &.avator-1 {
            border: 5px solid #b6bfcd;
          }
          &.avator-2 {
            margin: 25px auto auto auto;
            width: 135px;
            height: 135px;
            border: 5px solid #f3d04b;
            & > div {
              width: 120px;
              height: 120px;
            }
          }
          &.avator-3 {
            border: 5px solid #b0763c;
          }
        }
        .username {
          padding-top: 10px;
          font-size: 16px;
          font-weight: 700;
        }
        .score {
          padding-top: 10px;
          font-weight: 700;
          &.score-1 {
            color: #b6bfcd;
          }
          &.score-2 {
            color: #f3d04b;
          }
          &.score-3 {
            color: #b0763c;
          }
          .score-item {
            font-family: TCloud Number;
            font-size: 18px;
            font-weight: bold;
            padding-right: 3px;
          }
        }
      }
    }
  }
  .more-dataset {
    margin-top: 30px;
  }
}
</style>
